import { Box, Card, Group, ThemeIcon, Text } from "@mantine/core";

const CommunityStatCard = ({ icon, label, value, color }) => (
    <Card withBorder radius="md" p="md">
        <Group>
            <ThemeIcon color={color} variant="light" size="xl" radius="md">
                {icon}
            </ThemeIcon>
            <Box>
                <Text size="xs" c="dimmed" tt="uppercase" fw={600}>{label}</Text>
                <Text fw={700} size="xl">{value.toLocaleString()}</Text>
            </Box>
        </Group>
    </Card>
);

export default CommunityStatCard